import { render, staticRenderFns } from "./GroupPrepaidAI.vue?vue&type=template&id=4bda27ee&"
import script from "./GroupPrepaidAI.vue?vue&type=script&lang=js&"
export * from "./GroupPrepaidAI.vue?vue&type=script&lang=js&"
import style0 from "./GroupPrepaidAI.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports